import { useQuery } from '@tanstack/react-query'
import { Store } from 'lucide-react'
import { fetchAdminSociedades } from '../../api'
import { PageHeader } from '../../components/PageHeader'
import { Skeleton } from '../../components/ui/skeleton'
import { Card } from '../../components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table'

export function SociedadesPage() {
  const query = useQuery({ queryKey: ['admin', 'sociedades'], queryFn: fetchAdminSociedades })

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        icon={Store}
        title="Sociedades"
        description={
          query.data
            ? `${query.data.length} ${query.data.length === 1 ? 'Sociedad' : 'Sociedades'}, cruzando todas las Empresas.`
            : 'Todos los negocios/marcas operativos, cruzando todas las Empresas.'
        }
      />

      <Card className="overflow-hidden py-0">
        {query.isLoading && (
          <div className="flex flex-col gap-3 p-5">
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-5/6" />
            <Skeleton className="h-5 w-2/3" />
          </div>
        )}
        {query.isError && <p className="p-5 text-sm text-destructive">No se pudieron cargar las sociedades.</p>}
        {query.data && query.data.length === 0 && (
          <div className="flex flex-col items-center justify-center gap-2 py-14 text-center">
            <Store className="size-8 text-muted-foreground/40" />
            <p className="text-sm text-muted-foreground">Todavía no hay ninguna Sociedad.</p>
          </div>
        )}
        {query.data && query.data.length > 0 && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nombre</TableHead>
                <TableHead>Empresa</TableHead>
                <TableHead className="text-right">Números activos</TableHead>
                <TableHead>Alta</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {query.data.map((sociedad) => (
                <TableRow key={sociedad.id}>
                  <TableCell className="font-medium">{sociedad.nombre}</TableCell>
                  <TableCell className="text-muted-foreground">{sociedad.empresa_nombre}</TableCell>
                  <TableCell className="text-right tabular-nums">{sociedad.channel_accounts_activos}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {new Date(sociedad.created_at).toLocaleDateString('es-CR')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  )
}
